import React from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export default function SensitiveBadge({
    className,
    children,
    dataPlaywrightId,
}: {
    className?: string;
    children: React.ReactNode;
    /** Optional test hook. Added for the QUESTION facet's two title badges, which need to be
     *  addressable post-hydration to prove the island did not drop the server's framing (rule 32). */
    dataPlaywrightId?: string;
}) {
    return (
        <Badge
            variant="outline"
            data-playwright-id={dataPlaywrightId}
            className={cn(
                "border-[color-mix(in_srgb,var(--line-color)_82%,transparent)] bg-[color-mix(in_srgb,var(--background2)_92%,var(--background1))] text-[color-mix(in_srgb,var(--text-main)_72%,var(--text-muted))] uppercase tracking-[0.14em]",
                className,
            )}
        >
            {children}
        </Badge>
    );
}
